/* eslint-disable @typescript-eslint/no-use-before-define */
/**
 *
 * Component: SingleSelectFilter
 * Date: 7/8/2020
 *
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Text,
  Select,
  Option,
  // SelectOption
} from 'components/common';

import { FilterLayout } from '../index';
import styles from './style.module.css';

function SingleSelectFilter({
  filter,
  selectedValues = [],
  filterValues,
  onFilterApplied,
  moreFilter,
}: any) {
  const [displayedFilterValues, setDisplayedFilterValues] = useState([]);
  const [maxCharacters, setMaxCharacters] = useState(20);
  const [selectedValuesState, setSelectedValuesState] =
    useState(selectedValues);

  useEffect(() => {
    filterDisplayedValues();
  }, []);

  /**
   * Appends options on newDisplayFilterValues and also calculates the maxCharacter length, for all filterValues.
   */
  const filterDisplayedValues = () => {
    const newDisplayedFilterValues: Array<never> = [];
    let newMaxCharacters = maxCharacters;
    if (filterValues)
      filterValues.forEach((filterValue: any) => {
        newDisplayedFilterValues.push(
          // eslint-disable-next-line react/jsx-no-undef
          (<Option key={filterValue._id}>{filterValue.name}</Option>) as never,
        );
        if (filterValue.name && filterValue.name.length > newMaxCharacters) {
          newMaxCharacters = filterValue.name.length;
        }
      });
    setDisplayedFilterValues(newDisplayedFilterValues);
    setMaxCharacters(newMaxCharacters);
  };

  /**
   * if more filters than applies filter based on filter key, else sets the value in selectedValue State.
   * @param {String} values : Selected value from filter.
   */
  const handleChange = (values: any) => {
    if (moreFilter) {
      onFilterApplied(filter.key, values);
    } else {
      setSelectedValuesState(values);
    }
  };

  /**
   * Displays Filter Values.
   * @returns {JSX} to get the filter UI.
   */
  const getFilter = () => {
    if (filterValues?.length > 0)
      return (
        <>
          <Text type="subtitle" text={filter.name} />
          <Select
            allowClear
            defaultValue={selectedValues || ''}
            onChange={handleChange}
            dropdownStyle={{
              minWidth: `${maxCharacters * 7.8 + 50}px`,
            }}
          >
            {displayedFilterValues}
          </Select>
        </>
      );
    return null;
  };

  /**
   * Wrapped in FilterLayout Component
   * @returns {JSX} filter component UI based on Select or the FilterLayout Component.
   */
  const getFilterComponent = () => {
    let component;
    if (moreFilter) {
      component = getFilter();
    } else {
      component = (
        <FilterLayout
          onApply={() => onFilterApplied(filter.key, [selectedValuesState])}
        >
          {getFilter()}
        </FilterLayout>
      );
    }
    return component;
  };

  return <div className={styles.container}>{getFilterComponent()}</div>;
}

export default SingleSelectFilter;
